import { useEffect, useRef, useState } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import getUserMenuItems from "./AdminMenuContent";
import AdminSideBar from "./AdminSideBar";
import { adminReqConfig, api } from "../../include/api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import AdminFooter from "../common/AdminFooter";
import { useNotification } from "../../Toast/ToastProvider";
import { ERROR, SUCCESS } from "../../include/constant";
import { ChevronDown, X } from "react-feather";
import Papa from "papaparse";
import "../../styles/CategoryProductList.css";
import { formatShortMonthDateYear, getAdmin } from "../../include/function";

const ListCoupon = () => {
  const navigate = useNavigate();
  const homeLink = "/admin";
  const [fetchLoading, setFetchLoading] = useState(true);
  const [couponList, setCouponList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();
  const toast = useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const user = getAdmin();
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);
  const [filterValues, setFilterValues] = useState({
    type: "",
    customerGroup: "",
    customerType: "",
    brand: "",
    category: "",
    product: "",
  });
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig(),
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Find permission entry where pageTitle === "Product"
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Coupon",
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);
  // Fetch lookup data
  useEffect(() => {
    api
      .get("/brand/", adminReqConfig())
      .then((res) => setBrands(res.data.data || []))
      .catch(() => setBrands([]));
    api
      .get("/category/?flag=exceptHome", adminReqConfig())
      .then((res) => setCategories(res.data.data || []))
      .catch(() => setCategories([]));
    api
      .get("/product/", adminReqConfig())
      .then((res) => setProducts(res.data.data || []))
      .catch(() => setProducts([]));
  }, []);

  // Fetch coupons
  const getCoupon = () => {
    setFetchLoading(true);
    api
      .get("/voucher/", adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const normalizedData = response.data.data.map((coupon) => ({
            ...coupon,
            categoryName: Array.isArray(coupon.categoryName)
              ? coupon.categoryName
              : [],
            brandName: Array.isArray(coupon.brandName) ? coupon.brandName : [],
            productName: Array.isArray(coupon.productName)
              ? coupon.productName
              : [],
            customerGroup: Array.isArray(coupon.customerGroup)
              ? coupon.customerGroup
              : [],
            customerType: Array.isArray(coupon.customerType)
              ? coupon.customerType
              : [],
            customerName: Array.isArray(coupon.customerName)
              ? coupon.customerName
              : [],
          }));
          setCouponList(normalizedData);
          setFilteredData(normalizedData);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch coupons:", error);
        setCouponList([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    getCoupon();
  }, []);

  // Apply filters AND search client-side
  useEffect(() => {
    let result = [...couponList];

    // Apply dropdown filters
    if (filterValues.type) {
      result = result.filter((c) => c.type === filterValues.type);
    }
    if (filterValues.customerGroup) {
      result = result.filter((c) =>
        c.customerGroup.includes(filterValues.customerGroup),
      );
    }
    if (filterValues.customerType) {
      result = result.filter((c) =>
        c.customerType.includes(filterValues.customerType),
      );
    }
    if (filterValues.category) {
      result = result.filter((c) => c.category.includes(filterValues.category));
    }
    if (filterValues.brand) {
      result = result.filter((c) => c.brand.includes(filterValues.brand));
    }
    if (filterValues.product) {
      result = result.filter((c) => c.product.includes(filterValues.product));
    }

    // Apply search (real-time)
    if (searchQuery.trim()) {
      const query = searchQuery.trim().toLowerCase();
      result = result.filter(
        (coupon) =>
          coupon.code?.toLowerCase().includes(query) ||
          coupon.type?.toLowerCase().includes(query) ||
          coupon.customerGroup.some((group) =>
            group.toLowerCase().includes(query),
          ) ||
          coupon.customerType.some((type) =>
            type.toLowerCase().includes(query),
          ) ||
          coupon.categoryName.some((cat) =>
            cat.toLowerCase().includes(query),
          ) ||
          coupon.brandName.some((brand) =>
            brand.toLowerCase().includes(query),
          ) ||
          coupon.productName.some((prod) => prod.toLowerCase().includes(query)),
      );
    }

    setFilteredData(result);
    setCurrentPage(1);
  }, [filterValues, searchQuery, couponList, searchParams]);

  // Close filter panel on outside click
  const filterWrapperRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterPanelOpen &&
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isFilterPanelOpen]);

  const applyFilters = () => {
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    setFilterValues({
      type: "",
      customerGroup: "",
      customerType: "",
      brand: "",
      category: "",
      product: "",
    });
    setSearchQuery("");
    setIsFilterPanelOpen(false);
  };

  // Pagination Logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // ... [Rest of the handlers: handleView, handleEdit, handleDelete, CSV, etc.] remain unchanged ...

  const handleView = (id) => {
    navigate(`/admin/coupon/couponDetails/${id}`);
  };
  const handleEdit = (id) => {
    navigate(`/admin/coupon/couponAddNew?id=${id}`);
  };
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      api
        .delete(`/voucher/?id=${id}`, adminReqConfig())
        .then((response) => {
          if (response) {
            toast({ type: SUCCESS, message: response.data.message });
            setCouponList((prev) => prev.filter((p) => p.id !== id));
            setFilteredData((prev) => prev.filter((p) => p.id !== id));
          }
        })
        .catch((error) => {
          toast({ type: ERROR, message: "Failed to delete product" });
          console.error("Delete error:", error);
        });
    }
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };

  const handleDownloadCSV = (exportScope = "current") => {
    let dataToExport = [];

    // ✅ PRIORITY 1: If items selected → ALWAYS export selected (overrides everything)
    if (selectedData.length > 0) {
      dataToExport = couponList.filter((coupon) =>
        selectedData.includes(coupon.id),
      );
    }
    // ✅ PRIORITY 2: If "Export All" clicked → export entire dataset
    else if (exportScope === "all") {
      dataToExport = couponList;
    }
    // ✅ PRIORITY 3: Default → export current page items only
    else {
      dataToExport = currentItems;
    }

    if (dataToExport.length === 0) {
      toast({ type: ERROR, message: "No coupon data to download" });
      return;
    }

    const couponColumns = [
      "S.No",
      "Code",
      "Type",
      "BasedOn",
      "Value",
      "StartDate",
      "EndDate",
      "Category",
      "Brand",
      "Product",
      "CustomerGroup",
      "CustomerType",
      "customer",
      "MinRequirements",
      "MaxCount",
      "AppliedCount",
      "CreateTimeStamp",
    ];

    const csvData = dataToExport.map((coupon, index) => {
      const joinArray = (arr) =>
        Array.isArray(arr) ? arr.join(", ") : arr || "";

      return {
        "S.No": index + 1,
        Code: coupon.code || "",
        Type: coupon.type || "",
        BasedOn: coupon.basedOn || "",
        Value: coupon.value || "",
        StartDate: coupon.startDate || "",
        EndDate: coupon.endDate || "",
        Category: joinArray(coupon.categoryName),
        Brand: joinArray(coupon.brandName),
        Product: joinArray(coupon.productName),
        CustomerGroup: joinArray(coupon.customerGroup),
        CustomerType: joinArray(coupon.customerType),
        customer: joinArray(coupon.customerName),
        MinRequirements: coupon.minRequirement || "",
        MaxCount: coupon.maxCount || "",
        AppliedCount: coupon.appliedCount || 0,
        CreateTimeStamp: coupon.createTimestamp
          ? new Date(coupon.createTimestamp).toISOString().split("T")[0]
          : "",
      };
    });

    const csv = Papa.unparse({
      fields: couponColumns,
      data: csvData,
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // ✅ Dynamic filename based on export type
    const fileName =
      selectedData.length > 0
        ? `Coupon_Selected_${selectedData.length}.csv`
        : exportScope === "all"
          ? "Coupon_All.csv"
          : `Coupon_Page${currentPage}.csv`;

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title="COUPONS LIST"
      />
      <div
        className="content-wrapper p-0"
        style={{
          marginLeft: isSidebarMinimized ? "80px" : "250px",
          flex: "1",
        }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          {fetchLoading ? (
            <p>Loading coupons...</p>
          ) : (
            <>
              <div className="rounded-5 bg-white py-24 ">
                <div className="row align-items-center px-24 py-10 mb-3">
                  {/* 1. Header */}
                  <div className="col-auto">
                    <h6 className="mb-0">All Coupons List</h6>
                  </div>

                  {/* 2. Search + Filter (takes remaining space) */}
                  <div className="col">
                    <div
                      className="filter-wrapper"
                      style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "500px",
                      }}
                      ref={filterWrapperRef}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Search coupons..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                        />
                        {searchQuery && (
                          <X
                            size={24}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSearchQuery("");
                              setCurrentPage(1);
                              setIsFilterPanelOpen(false);
                            }}
                            style={{
                              position: "absolute",
                              right: "40px",
                              cursor: "pointer",
                              color: "#999",
                              padding: "4px",
                              zIndex: 10,
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.color = "#666")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.color = "#999")
                            }
                          />
                        )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>
                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={(key, value) =>
                            setFilterValues((prev) => ({
                              ...prev,
                              [key]: value,
                            }))
                          }
                          onApply={applyFilters}
                          onClear={clearFilters}
                          brands={brands}
                          categories={categories}
                          products={products}
                          onClick={(e) => e.stopPropagation()}
                        />
                      )}
                    </div>
                  </div>

                  {/* 3. Add New + 4. Options – aligned right in same row */}
                  <div className="col-auto d-flex align-items-center gap-2">
                    {productPermissions.add && (
                      <button
                        className="btn me-0 mb-0"
                        style={{
                          height: "40px",
                          width: "140px",
                          color: "white",
                          backgroundColor: "#2696D5",
                          border: "none",
                          borderRadius: "6px",
                        }}
                        onClick={() => navigate("/admin/coupon/couponAddNew")}
                      >
                        Add New
                      </button>
                    )}
                    <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                  </div>
                </div>

                {/* Table */}
                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead className="">
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Coupon Code
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Coupon Type
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Minimum Requirement
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Coupon Value
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Validity
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Product
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Usage Limit
                        </th>
                        <th
                          scope="col"
                          style={{
                            width: "120px",
                            fontSize: "15px",
                            textAlign: "center",
                          }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((coupon) => {
                          return (
                            <tr key={coupon.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  style={{ borderColor: "#c5d5f5" }}
                                  className="form-check-input"
                                  checked={selectedData.includes(coupon.id)}
                                  onChange={() => handleSelectOne(coupon.id)}
                                />
                              </td>
                              <td>{coupon.code}</td>
                              <td>{coupon.type}</td>
                              <td>
                                {coupon.customerGroup.join(", ")}
                                {coupon.customerType.length > 0
                                  ? `, ${coupon.customerType.join(", ")}`
                                  : ""}
                                {coupon.customerName.length > 0
                                  ? coupon.customerName.length > 1
                                    ? `, ${coupon.customerName[0]} +${
                                        coupon.customerName.length - 1
                                      }`
                                    : `, ${coupon.customerName[0]}`
                                  : ""}
                              </td>
                              <td>{coupon.minRequirement}</td>
                              <td>
                                {coupon.type === "percentage"
                                  ? `${coupon.value}%`
                                  : `₹${coupon.value}`}
                              </td>
                              <td>
                                {formatShortMonthDateYear(coupon.startDate)} -{" "}
                                {formatShortMonthDateYear(coupon.endDate)}
                              </td>
                              <td>
                                {coupon.productName.length > 0
                                  ? coupon.productName.length > 1
                                    ? ` ${coupon.productName[0]} +${
                                        coupon.productName.length - 1
                                      }`
                                    : `${coupon.productName[0]}`
                                  : ""}
                              </td>
                              <td>
                                Total:{coupon.maxCount}
                                <br />
                                Used:{coupon.appliedCount}
                              </td>
                              <td style={{ position: "relative" }}>
                                <div className="d-flex gap-1">
                                  {productPermissions.view && (
                                    <button
                                      style={{
                                        backgroundColor: "#D9EBFF",
                                        height: "39px",
                                        width: "50px",
                                        border: "none",
                                        borderRadius: "4px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        padding: "0",
                                        margin: "0",
                                        fontSize: "14px",
                                        lineHeight: 1,
                                        color: "inherit",
                                        outline: "none",
                                      }}
                                      onClick={() => handleView(coupon.id)}
                                    >
                                      <img
                                        src="/assets/images/view-icon.png"
                                        alt="View"
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          objectFit: "contain",
                                        }}
                                        onError={(e) =>
                                          (e.target.style.display = "none")
                                        }
                                      />
                                    </button>
                                  )}
                                  {productPermissions.edit && (
                                    <button
                                      style={{
                                        backgroundColor: "#D9EBFF",
                                        height: "39px",
                                        width: "50px",
                                        border: "none",
                                        borderRadius: "4px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        padding: "0",
                                        margin: "0",
                                        fontSize: "14px",
                                        lineHeight: 1,
                                        color: "inherit",
                                        outline: "none",
                                      }}
                                      onClick={() => handleEdit(coupon.id)}
                                    >
                                      <img
                                        src="/assets/images/edit-icon.png"
                                        alt="Edit"
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          objectFit: "contain",
                                        }}
                                        onError={(e) =>
                                          (e.target.style.display = "none")
                                        }
                                      />
                                    </button>
                                  )}
                                  {productPermissions.delete && (
                                    <button
                                      style={{
                                        backgroundColor: "#D9EBFF",
                                        height: "39px",
                                        width: "50px",
                                        border: "none",
                                        borderRadius: "4px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        padding: "0",
                                        margin: "0",
                                        fontSize: "14px",
                                        lineHeight: 1,
                                        color: "inherit",
                                        outline: "none",
                                      }}
                                      onClick={() => handleDelete(coupon.id)}
                                    >
                                      <img
                                        src="/assets/images/delete-icon.png"
                                        alt="Delete"
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          objectFit: "contain",
                                        }}
                                        onError={(e) =>
                                          (e.target.style.display = "none")
                                        }
                                      />
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center py-4">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} Lists
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;

                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }

                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }

                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
          <AdminFooter isSidebarMinimized={isSidebarMinimized} />
        </section>
      </div>
    </>
  );
};

export default ListCoupon;

const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const dropdownRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
  ];
  const handleSelect = (opt) => {
    setSelected(opt.label);
    setIsOpen(false);

    if (opt.value === "export") {
      handleDownloadCSV("current");
    } else if (opt.value === "exportAll") {
      handleDownloadCSV("all");
    }

    setSelected("Options");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  brands,
  categories,
  products,
  onClick,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "500px",
        overflowY: "auto",
        marginTop: "10px",
      }}
      onClick={onClick}
    >
      <div className="row g-3">
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.type}
            onChange={(e) => onFilterChange("type", e.target.value)}
          >
            <option value="">Coupon Type</option>
            <option value="percentage">Percentage</option>
            <option value="price">Price</option>
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.customerGroup}
            onChange={(e) => onFilterChange("customerGroup", e.target.value)}
          >
            <option value="">B2B /B2C</option>
            <option value="b2b">B2B</option>
            <option value="b2c">B2C</option>
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.customerType}
            onChange={(e) => onFilterChange("customerType", e.target.value)}
          >
            <option value="">Customer Type</option>
            <option value="dealer">Dealer</option>
            <option value="sub dealer">Sub Dealer</option>
            <option value="individual">Individual</option>
            <option value="engineer">Engineer</option>
            <option value="builder">Builder</option>
            <option value="architect">Architect</option>
            <option value="contractor">Contractor</option>
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.category}
            onChange={(e) => onFilterChange("category", e.target.value)}
          >
            <option value="">Categories</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.brand}
            onChange={(e) => onFilterChange("brand", e.target.value)}
          >
            <option value="">Brand</option>
            {brands.map((brand) => (
              <option key={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.product}
            onChange={(e) => onFilterChange("product", e.target.value)}
          >
            <option value="">Product</option>
            {products.map((product) => (
              <option key={product.id} value={product.id}>
                {product.name}
                {product.brandName ? `(${product.brandName})` : ""}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};
